import {schema} from 'normalizr';

import schemaBlockPages from "../blockPages/schema";

export default new schema.Entity('sets', {
  blockPages: [schemaBlockPages],
});